/*
  Blog "Učitaj više": loads the next page of articles into the current grid
  instead of navigating to it. The button stays a normal link to the next
  page, so it still works without JavaScript or if a request fails.
*/
class BlogLoadMore {
  constructor(root) {
    this.root = root;
    this.grid = root.querySelector('[data-blog-grid]');
    this.bindButton();
  }

  bindButton() {
    this.button = this.root.querySelector('[data-blog-load-more]');
    if (!this.button || !this.grid) return;
    this.button.addEventListener('click', (event) => this.loadNext(event));
  }

  async loadNext(event) {
    event.preventDefault();
    const link = event.currentTarget;
    if (link.getAttribute('aria-busy') === 'true') return;

    link.setAttribute('aria-busy', 'true');
    link.classList.add('is-loading');

    try {
      const response = await fetch(link.href, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const page = new DOMParser().parseFromString(await response.text(), 'text/html');

      const newCards = Array.from(page.querySelectorAll('[data-blog-grid] > *'));
      const firstIndex = this.grid.children.length;
      newCards.forEach((card) => this.grid.appendChild(document.importNode(card, true)));

      // Swap in the next page's button, or drop it on the last page.
      const pagination = this.root.querySelector('[data-blog-pagination]');
      const nextPagination = page.querySelector('[data-blog-pagination]');
      if (pagination && nextPagination) {
        pagination.replaceWith(document.importNode(nextPagination, true));
        this.bindButton();
      } else if (pagination) {
        pagination.remove();
      }

      // Move focus to the first new article so keyboard users continue from there.
      this.grid.children[firstIndex]?.querySelector('a')?.focus({ preventScroll: true });
    } catch (error) {
      window.location.href = link.href;
    } finally {
      link.removeAttribute('aria-busy');
      link.classList.remove('is-loading');
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-blog-index]').forEach((root) => new BlogLoadMore(root));
});
